import { ReactNode } from "react";
import { Fade } from "@remo-co/ui-core/src/components/Fade";

interface Props {
  children: ReactNode;
}

export const AuthBottomBlock = ({ children }: Props) => (
  <Fade in>
    <div className="auth-bottom">{children}</div>
  </Fade>
);
